import { useEffect, useState } from 'react';
import PostCard from '../components/Blog/PostCard';
import { normalizePosts } from '../utils/normalizePosts';
import { usePageMeta, SITE_URL, SITE_NAME } from '../hooks/usePageMeta';
import rawPosts from '../data/postsStatic.json';

// Normalizado uma única vez no carregamento do módulo: os dados já estão
// disponíveis no bundle (gerados por `npm run fetch:posts` antes do build),
// então o conteúdo aparece no primeiro render — sem isso, a pré-renderização
// (Puppeteer) capturaria a página vazia e a hidratação no cliente entraria
// em conflito com o HTML pré-renderizado.
const staticPosts = normalizePosts(Array.isArray(rawPosts) ? rawPosts : []);

export default function BlogPage(){
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 12;
    const [posts] = useState(staticPosts);

    usePageMeta({
        title: 'Bysetup — Guias e comparativos para escolher seu computador',
        description: 'Recomendações de computadores para comprar melhor: guias práticos, comparativos e listas atualizadas de notebooks, PCs e setups completos.',
        path: '/',
        jsonLd: {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: SITE_NAME,
            url: SITE_URL,
            inLanguage: 'pt-BR',
            description: 'Guias, comparativos e recomendações de computadores, notebooks e setups.',
            publisher: {
                '@type': 'Organization',
                name: SITE_NAME,
                url: SITE_URL,
                logo: `${SITE_URL}/logo512.png`
            }
        }
    });

    useEffect(() => {
        const header = document.querySelector('header');
        if (header) {
            header.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
    }, [currentPage]);

    // Rede de segurança: garante ordem desc por data de publicação mesmo que
    // a fonte de dados (postsStatic.json) não venha ordenada.
    const sortedPosts = [...posts].sort(
        (a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)
    );

    const totalPages = Math.ceil(sortedPosts.length / postsPerPage);

    const start = (currentPage - 1) * postsPerPage;
    const end = start + postsPerPage;

    const currentPosts = sortedPosts.slice(start, end);

    const handlePrevious = () => {
        if (currentPage > 1){
            setCurrentPage(currentPage - 1);
        }
    }

    const handleNext = () => {
        if (currentPage < totalPages){
            setCurrentPage(currentPage + 1);
        }
    }

  

    return (
    
        <main>
    
            <section className="py-5 border-bottom d-none d-md-block" style={{ backgroundColor: '#f8f9fa'}}>
                <div className="container">
                    <div className="col-lg-8 px-0">

                        <h1 className="display-7 fw-bold lh-sm mb-3">
                            Recomendações de computadores para comprar melhor
                        </h1>

                        <p className="fs-6 text-muted mb-0">
                            Guias práticos, comparativos e listas atualizadas para você.
                        </p>

                    </div>
                </div>
            </section>

            <section className="py-5">

                <div className="container">
                    <div className="row g-4">
                        {currentPosts.map((post) => (
                            <div key={post.id} className="col-12 col-md-6 col-xl-4">
                                <PostCard post={post}/>
                            </div> 
                        ))}
                    </div>
                </div>

                <nav className="d-flex justify-content-center align-items-center gap-3 mt-5">
                    <button
                        className="btn btn-outline-primary"
                        onClick={handlePrevious}
                        disabled={currentPage === 1}
                    >
                        ← Anterior
                    </button>

                    <span className="text-muted">
                        Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong>
                    </span>

                    <button
                        className="btn btn-outline-primary"
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                    >
                        Próxima →
                    </button>

                </nav>

            </section>

        </main>
    )
}